import React from 'react';
import styles from './StatusBadge.module.css';

const StatusBadge = ({ status }) => {
    const getStatusBackgroundColor = (status) => {
        switch (status) {
            case "Исполнитель": return "#FF930A";
            case "Оппортунист": return "#0171BB";
            case "Союзник": return "#FFC000";
            case "Противник": return "#3A3838";
            case "Оппозиционер": return "#A5A5A5";
            default: return "#0170ba";
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Исполнитель": return "#fff";
            case "Оппортунист": return "#fff";
            case "Союзник": return "#000";
            case "Противник": return "#fff";
            case "Оппозиционер": return "#fff";
            default: return "#fff";
        }
    };

    return (
        <span 
            className={styles.badge}
            style={{
                backgroundColor: getStatusBackgroundColor(status),
                color: getStatusColor(status)
            }}
        >
            {status}
        </span>
    );
};

export default StatusBadge;